import Error from 'components/pages/Error'
import { HistoryStackContextProps } from 'contexts/HistoryStackContext'
import { JwtContextProps } from 'contexts/JwtContext'
import React from 'react'
import { sendLog } from 'utils/log'

/**
 * Error Boundary
 * フロントJSのエラーをキャッチする
 */
export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error: any, errorInfo: any): void {
    this.setState({
      error,
      errorInfo,
    })
    console.error(error, errorInfo)
    // エラー時、ログ送信対象ならログスタックを送信
    sendLog(
      this.props.historyStack,
      `${errorInfo.componentStack}\n${error.stack}`,
      this.props.jwt[0]
    )
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return <Error />
    }

    return this.props.children
  }
}

/**
 * 型定義：Error BoundaryのProps
 */
export type ErrorBoundaryProps = {
  jwt: JwtContextProps
  historyStack: HistoryStackContextProps
}

/**
 * 型定義：Error BoundaryのState
 */
export type ErrorBoundaryState = {
  error: any
  errorInfo: any
}
